<div
  [class]="
    'main-toolbar flex flex-column gap-3 py-2 px-2 ' +
    sidebarService.toolbarSize$()
  ">
  <ng-template ngIf="toolbarItems">
    <div *ngFor="let toolbarItem of toolbarItems">
      <app-toolbar-button
        [icon]="toolbarItem.icon"
        [label]="toolbarItem.label"
        [labelVisibility]="navigationSize !== 'sm'"
        [tooltip]="toolbarItem.tooltip"
        [backLink]="backLink"
        [routerLink]="toolbarItem.routerLink"></app-toolbar-button>
    </div>
  </ng-template>

  <div>
    <app-toolbar-button
      [icon]="'fas fa-arrow-' + (navigationSize !== 'sm' ? 'left' : 'right')"
      [label]="'Navigation'"
      [tooltip]="'ein-/ ausfahren'"
      [labelVisibility]="navigationSize !== 'sm'"
      (click)="toggleNavigation()"></app-toolbar-button>
  </div>
</div>
